import { types, flow, applySnapshot } from 'mobx-state-tree';
import { makeRequest, errorResponse } from 'js/services/Network';

export default types
  .model('Dashboard', {
    isLoading: true,
    error: types.maybeNull(types.string),

    completed_orders: types.maybe(types.number),
    num_items: types.maybe(types.number),
    num_tokens: types.maybe(types.number),
    num_users: types.maybe(types.number),
    recent_users: types.maybe(types.number),
    recent_users_last_month: types.maybe(types.number),
    recent_items: types.maybe(types.number),
    recent_tokens: types.maybe(types.number),
    total_fees_collected: types.maybe(types.number),
    total_transacted: types.maybe(types.number),
    num_pending: types.maybe(types.number),
    payout_pending: types.maybe(types.number),
    claimed_bonus_count: types.maybe(types.number),
    transacted_users_without_bonus_count: types.maybe(types.number),
    shared_referrals_count: types.maybe(types.number),
    transacted_users_with_bonus_count: types.maybe(types.number),
    average_transactions_with_bonus: types.maybe(types.number),
    not_used_bonus_count: types.maybe(types.number)
  })
  .views(self => ({
    get completed_orders_human() {
      return self.completed_orders.toLocaleString();
    },
    get num_items_human() {
      return self.num_items.toLocaleString();
    },
    get num_tokens_human() {
      return self.num_tokens.toLocaleString();
    },
    get num_users_human() {
      return self.num_users.toLocaleString();
    },
    get recent_users_human() {
      return self.recent_users.toLocaleString();
    },
    get recent_users_last_month_human() {
      return self.recent_users_last_month.toLocaleString();
    },
    get recent_items_human() {
      return self.recent_items.toLocaleString();
    },
    get recent_tokens_human() {
      return self.recent_tokens.toLocaleString();
    },
    get total_fees_collected_human() {
      return self.total_fees_collected.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    get total_transacted_human() {
      return self.total_transacted.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    get payout_pending_human() {
      return self.payout_pending.toLocaleString(undefined, { minimumFractionDigits: 2 });
    },
    get num_pending_human() {
      return self.num_pending.toLocaleString();
    },
  }))
  .actions(self => ({
    load: flow(function* load(reload = false) {
      self.isLoading = true;
      try {
        const response = yield makeRequest('admin-dashboard-data', self, reload ? { reload } : null);
        applySnapshot(self, response.data);
      } catch (error) {
        self.error = errorResponse(error);
      }
      self.isLoading = false;
    }),
  }));
